import React from 'react';
import CompanyInfo from './CompanyInfo';
import ContactInfo from './ContactInfo';
import HostingInfo from './HostingInfo';
import IntellectualProperty from './IntellectualProperty';
import PrivacyPolicy from './PrivacyPolicy';

const LegalNotices = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Legal Notices</h1>
      <CompanyInfo />
      <ContactInfo />
      <HostingInfo />
      <PrivacyPolicy />
      <IntellectualProperty />
    </div>
  );
};

export default LegalNotices;